// Cascading roofing catalog: Category -> Brand -> Product line -> Colors
const c = (name, hex) => ({ name, hex });

export const CATALOG = {
  Shingle: {
    GAF: {
      "Timberline HDZ": [c("Charcoal", "#3a3a3c"), c("Weathered Wood", "#6b5b4f"), c("Pewter Gray", "#8a8d8f"), c("Barkwood", "#4a3c2e"), c("Shakewood", "#9b7d5a"), c("Hickory", "#7a5c43")],
      "Timberline UHDZ": [c("Charcoal", "#3a3a3c"), c("Slate", "#586169"), c("Pewter Gray", "#8a8d8f"), c("Weathered Wood", "#6b5b4f"), c("Hunter Green", "#2f4531")],
      "Grand Sequoia": [c("Charcoal", "#33322f"), c("Weathered Wood", "#6b5b4f"), c("Dusky Gray", "#6d6f72"), c("Autumn Brown", "#5a4130")],
    },
    Atlas: {
      "Pinnacle Pristine": [c("Black Shadow", "#2b2b2d"), c("Weathered Timber", "#6a5847"), c("Pewter", "#8a8d8f"), c("Driftwood", "#8a7f6b"), c("Hearthstone Gray", "#6d6f72")],
      "StormMaster Shake": [c("Black Shadow", "#2b2b2d"), c("Pristine Hickory", "#7a5c43"), c("Weathered Wood", "#6b5b4f"), c("Slate", "#586169")],
    },
    CertainTeed: {
      "Landmark": [c("Moire Black", "#2c2c2e"), c("Weathered Wood", "#6b5b4f"), c("Georgetown Gray", "#7d8084"), c("Burnt Sienna", "#7a4a34"), c("Cobblestone Gray", "#6d6f72")],
      "Landmark PRO": [c("Max Def Charcoal", "#33333a"), c("Max Def Weathered Wood", "#6b5b4f"), c("Pewter", "#8a8d8f"), c("Driftwood", "#8a7f6b")],
      "Presidential Shake": [c("Charcoal Black", "#2c2c2e"), c("Autumn Blend", "#6a4a32"), c("Shadow Gray", "#5b6169"), c("Weathered Wood", "#6b5b4f")],
    },
    "Owens Corning": {
      "Duration": [c("Onyx Black", "#26262a"), c("Estate Gray", "#5f6469"), c("Driftwood", "#8a7f6b"), c("Desert Tan", "#a58a63"), c("Teak", "#6b4a30")],
      "Duration Designer": [c("Aged Copper", "#5a6b52"), c("Sand Dune", "#b09a70"), c("Slate Blue", "#4a5866"), c("Merlot", "#5a2e33")],
      "Berkshire": [c("Manchester Gray", "#5b5f63"), c("Cambridge Black", "#2b2b2d"), c("Concord Brown", "#4f3b2c")],
    },
    "F Wave": {
      "REVIA": [c("Weathered Ash", "#7d8084"), c("Charcoal Smoke", "#3a3a3c"), c("Aged Oak", "#7a5c43"), c("Slate", "#586169"), c("Coastal Gray", "#8a8d8f")],
    },
  },
  Metal: {
    Berridge: {
      "Cee-Lock Standing Seam": [c("Matte Black", "#1a1a1a"), c("Charcoal Gray", "#3d3f41"), c("Regal Blue", "#26405c"), c("Copper-Cote", "#8a5a2b"), c("Hartford Green", "#233c2c"), c("Colonial Red", "#6e2b28")],
      "Zee-Lock Standing Seam": [c("Zinc Gray", "#6f7376"), c("Matte Black", "#1a1a1a"), c("Sierra Tan", "#9a7f5a"), c("Regal White", "#e8e8e6"), c("Hemlock Green", "#2f4531")],
      "FW-12 Panel": [c("Galvalume Silver", "#b7b9ba"), c("Charcoal Gray", "#3d3f41"), c("Colonial Red", "#6e2b28"), c("Almond", "#d8cdb4")],
    },
    Mueller: {
      "Standing Seam": [c("Galvalume", "#b7b9ba"), c("Matte Black", "#1a1a1a"), c("Ash Gray", "#8d9194"), c("Burnished Slate", "#4a3b34"), c("Gallery Blue", "#26405c"), c("Hunter Green", "#233c2c")],
      "R-Panel": [c("Polar White", "#eeeeec"), c("Charcoal", "#3d3f41"), c("Barn Red", "#6e2b28"), c("Desert Sand", "#c8b48c"), c("Rustic Red", "#7a3b2f")],
    },
    CMR: {
      "Standing Seam": [c("Matte Black", "#1a1a1a"), c("Charcoal Gray", "#3d3f41"), c("Slate Blue", "#3f4d63"), c("Copper Penny", "#8a5a2b"), c("Forest Green", "#233c2c"), c("Barn Red", "#6e2b28"), c("Silver Metallic", "#b7b9ba")],
      "Metal Shingle": [c("Weathered Copper", "#6a5a3f"), c("Slate Gray", "#5f6469"), c("Charcoal", "#3d3f41"), c("Mustang Brown", "#4f3b2c")],
      "Stone-Coated Steel": [c("Charcoal Blend", "#3a3d42"), c("Terracotta", "#a8532e"), c("Weathered Timber", "#6b5b4f"), c("Slate Green", "#3f5140")],
    },
  },
  "Slate & Tile": {
    Ludowici: {
      "Spanish Clay Tile": [c("Terra Cotta", "#a8532e"), c("Spanish Red", "#8f3a2c"), c("Golden Blend", "#b07a3c"), c("Sandstone", "#c8b48c")],
      "Clay Slate Tile": [c("Charcoal", "#33333a"), c("Aged Bronze", "#5a4a35"), c("Green Blend", "#3f5140"), c("Gray", "#6d6f72")],
    },
    Boral: {
      "Barcelona 900": [c("Terracotta", "#a8532e"), c("Spanish Blend", "#9a4a30"), c("Brown Blend", "#5a4130"), c("Sandstone", "#c8b48c")],
      "Saxony Slate": [c("Charcoal Slate", "#3a3d42"), c("Gray Slate", "#6d6f72"), c("Aged Cedar", "#6b4a30"), c("Vermont Black", "#2b2b2d")],
    },
    Brava: {
      "Composite Slate": [c("Slate Gray", "#4a4d52"), c("Vermont Black", "#2b2b2d"), c("Aged Bronze", "#5a4a35"), c("Mossy Green", "#3f5140"), c("Multi-Blend", "#6d6f72")],
      "Cedar Shake": [c("Natural Cedar", "#9b7d5a"), c("Weathered Gray", "#8a8d8f"), c("Driftwood", "#8a7f6b"), c("Antique Brown", "#6b4a30")],
      "Spanish Barrel Tile": [c("Terracotta", "#a8532e"), c("Sunset Blend", "#b0603c"), c("Sonoma Blend", "#9a4a30"), c("Adobe", "#c8905a")],
    },
  },
  Flat: {
    GAF: {
      "EverGuard TPO": [c("White", "#f1f1ec"), c("Gray", "#9a9c9e"), c("Tan", "#c8b48c")],
    },
    Carlisle: {
      "Sure-Weld TPO": [c("White", "#f1f1ec"), c("Gray", "#9a9c9e")],
      "FleeceBACK TPO": [c("White", "#f1f1ec"), c("Gray", "#9a9c9e"), c("Tan", "#c8b48c")],
    },
    Firestone: {
      "UltraPly TPO": [c("White", "#f1f1ec"), c("Gray", "#9a9c9e"), c("Tan", "#c8b48c")],
    },
  },
};

export const CATEGORIES = Object.keys(CATALOG);
